import CloseIcon from '@mui/icons-material/Close';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Snackbar from '@mui/material/Snackbar';
import {styled} from '@mui/material/styles';
import React from 'react';

import {pxToRem} from '../../utils';

const StyledSnackbar = styled(Snackbar)(({theme, severity, isalert}) => ({
  backgroundColor:
    severity === 'success'
      ? theme.palette.success.light2
      : severity === 'error'
        ? theme.palette.error.light2
        : severity === 'warning'
          ? theme.palette.warning.light2
          : theme.palette.primary.main,
  borderRadius: pxToRem(8),
  '& .MuiSnackbarContent-root': {
    display: 'flex',
    flexGrow: 'initial',
    minWidth: pxToRem(288),
    color: theme.palette.grey[100],
    fontSize: pxToRem(16),
    fontWeight: 500,
    borderRadius: pxToRem(8),
    padding: `${pxToRem(6)} ${pxToRem(16)}`,
    backgroundColor:
      severity === 'success'
        ? theme.palette.success.light2
        : severity === 'error'
          ? theme.palette.error.light2
          : severity === 'warning'
            ? theme.palette.warning.light2
            : theme.palette.primary.main,
  },
  '& .MuiSnackbarContent-message': {
    ...(isalert === 'true' ? {} : {width: '100%'}),
    display: 'flex',
    maxWidth: pxToRem(500),
  },
}));

const StyledSvgDiv = styled('div')(({theme}) => ({
  width: '40px',
  height: '40px',
  position: 'absolute',
  marginTop: theme.spacing(-2),
  backgroundColor: theme.palette.white,
  borderRadius: '50%',
  border: `${pxToRem(5)} solid`,
  borderColor: theme.palette.primary.medium,
  transform: `scale(1.6) translateX(5px) translateY(-10px)`,
  boxShadow: theme.palette.boxShadow.type1,
  padding: theme.spacing(0.6),
  '& svg': {
    width: '100%',
    height: '100%',
  },
}));

const StyledMessageDiv = styled('div')(({theme, isalert}) => ({
  flex: `1 1 100%`,
  paddingLeft: isalert === 'true' ? 0 : theme.spacing(7),
  color: isalert === 'true' ? theme.palette.black : theme.palette.white,
  fontWeight: isalert === 'true' ? 400 : 700,
  minWidth: 350,
  maxWidth: 500,
}));

const CustomSnackbar = ({
  message,
  handleClose,
  isOpen,
  Icon,
  autoHideDuration,
  ActionComponent,
  isAlert,
  severity,
  anchorOriginVertical,
}) => {
  const action = isAlert && (
    <IconButton onClick={handleClose} sx={{color: (theme) => theme.palette.black}}>
      <CloseIcon />
    </IconButton>
  );
  return (
    <StyledSnackbar
      isalert={`${isAlert}`}
      severity={severity}
      open={isOpen}
      autoHideDuration={autoHideDuration}
      onClose={handleClose}
      message={
        <>
          {Icon && (
            <StyledSvgDiv>
              <Box sx={{maxWidth: '100%', maxHeight: '100%'}}>
                <Icon />
              </Box>
            </StyledSvgDiv>
          )}
          <StyledMessageDiv isalert={`${isAlert}`}>{message}</StyledMessageDiv>
          {ActionComponent && <ActionComponent />}
        </>
      }
      anchorOrigin={{
        vertical: anchorOriginVertical,
        horizontal: 'right',
      }}
      action={action}
    />
  );
};

export default CustomSnackbar;
